import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../services/api";
import { Row, Col } from "react-bootstrap";
import styles from "./Login.module.css";
import Logo from "../../components/Logo";
import Loading from "../../components/Loading";
import Required from "../../components/Required";
import {
  IntegerNumber,
  InputDocument,
  Phone,
  Cep,
  File,
  InputText,
  InputEmail,
  Password,
} from "../../components/Input";
import Checkbox from "../../components/Checkbox";
import Slct from "../../components/Slct";
import DatePicker from "../../components/DatePicker";
import { ModalConfirm } from "../../components/Modal";
import { toast } from "react-toastify";
import { validateForm, validateStyle } from "../../components/ValidateForm";
import Button from "../../components/Button";
import useFormat from "../../hooks/utils/useFormat";

export default function Cadastro() {
  const [isWaitingResponse, setisWaitingResponse] = useState(true);
  const [isLoadingEssential, setisLoadingEssential] = useState(true);
  const [isLoadingSave, setisLoadingSave] = useState(false);
  const [isLoadingCities, setisLoadingCities] = useState(false);
  useEffect(() => {
    setisWaitingResponse(isLoadingEssential || isLoadingSave);
  }, [isLoadingEssential, isLoadingSave]);

  const { code } = useParams();

  const { stringToDate } = useFormat();

  const [wrongCode, setwrongCode] = useState(false);
  const [commercial, setcommercial] = useState();
  const [states, setstates] = useState();
  const [cities, setcities] = useState();
  const [trainee, settrainee] = useState({
    state_id: null,
  });

  useEffect(() => {
    const invalidate = () => {
      setwrongCode(true);
      toast.error("Código de acesso inválido.");
      return false;
    };
    (async () => {
      try {
        setisLoadingEssential(true);
        if (!code) return invalidate();
        const { data: __commercial } = await api.post("sessions-graduating/first-access", { code: code });
        if (!__commercial?.id) return invalidate();
        setcommercial(__commercial);
        const { data: _states } = await api.get("state");
        setstates(
          _states.map(__state => ({
            value: __state.id,
            label: __state.name,
            uf: __state.uf,
          })),
        );
      } catch (__error) {
        console.log("__error", __error);
        invalidate();
      } finally {
        setisLoadingEssential(false);
      }
    })();
  }, [code]);

  useEffect(() => {
    if (trainee?.state_id) {
      (async () => {
        try {
          setisLoadingCities(true);
          const { data: _cities } = await api.get(`cities/${trainee.state_id}`);
          setcities(
            _cities.map(__city => ({
              value: __city.id,
              label: __city.name,
            })),
          );
        } catch (__error) {
          console.log("__error", __error);
          toast.error("Erro ao tentar carregar as cidades.");
        } finally {
          setisLoadingCities(false);
        }
      })();
    }
  }, [trainee?.state_id]);

  const signUp = async () => {
    const uploadFile = async (__file, __key) => {
      if (!__file) return;
      try {
        let _body = new FormData();
        _body.append("file", __file);
        const _response = await api.post("/files/external", _body, {
          headers: {
            "Content-Type": "multipart/form-data",
            [__key]: 1,
            code: code,
          },
        });
        return _response;
      } catch (__error) {
        toast.error("Problemas ao subir o arquivo.");
        console.log("__error", __error);
      }
    };

    try {
      setisLoadingSave(true);
      // Files Upload
      let _file_ids = [];
      for (const __file of Object.entries(trainee?.files_to_upload || {})) {
        const { data: _file } = await uploadFile(__file[1], __file[0]);
        _file_ids.push(_file.id);
      }
      // Trainee Data
      const _trainee_submit = {
        name: trainee?.name,
        email: trainee?.email,
        instagram: trainee?.instagram,
        cpf: trainee?.cpf,
        rg: trainee?.rg,
        ssp: trainee?.ssp,
        marital_status: trainee?.marital_status,
        gender: trainee?.gender,
        date_birth: stringToDate(trainee?.date_birth),
        phone: trainee?.phone,
        cell: trainee?.cell,
        legal_responsible1: trainee?.legal_responsible1,
        legal_cell1: trainee?.legal_cell1,
        legal_responsible2: trainee?.legal_responsible2,
        legal_cell2: trainee?.legal_cell2,
        cep: trainee?.cep,
        number: trainee?.number,
        address: trainee?.address,
        district: trainee?.district,
        complement: trainee?.complement,
        city_id: trainee?.city_id,
        state_id: trainee?.state_id,
        due_date: trainee?.due_date,
        is_whatsapp: trainee?.is_whatsapp,
        is_member: false,
        ssp_state_id: trainee?.ssp_state_id,
        contract_date: trainee?.contract_date,
        files: _file_ids,
        code: code,
        password: trainee?.password,
        commercial_id: commercial?.id,
      };
      await api.post("/trainee/first-access", _trainee_submit);
      setwizard(3);
      toast.success("Pré-Registro efetuado com sucesso.");
    } catch (__error) {
      toast.error("Algo errado aconteceu ao tentar completar o cadastro. Entre em contato com a nossa equipe.");
      console.log("__error", __error);
    } finally {
      setisLoadingSave(false);
    }
  };

  const [wizard, setwizard] = useState(0);

  return (
    <>
      <div className={`${styles.wrapLogin} ${wizard > 0 && "-big"}`} id="form_container" style={validateStyle}>
        {!wrongCode ? (
          <>
            {!isLoadingEssential ? (
              <>
                <div className="text-center mb-4">
                  <Logo />
                </div>
                {wizard === 0 && (
                  <div className="text-center">
                    <p className="m-0">Você foi convidado para fazer parte da turma</p>
                    <p className="m-0">
                      <b>
                        {commercial?.course?.title} - {commercial?.year}.{commercial?.period}
                      </b>
                    </p>
                    <p className="small-label">{commercial?.institution?.title}</p>
                    <Button
                      color="primary"
                      onClick={() => {
                        setwizard(1);
                      }}
                      disabled={isWaitingResponse}
                    >
                      Iniciar Registro
                    </Button>
                  </div>
                )}
                {wizard < 3 && (
                  <div
                    style={{
                      opacity: wizard ? 1 : 0,
                      maxHeight: wizard ? "inherit" : "0px",
                      transition: ".25s ease",
                      transitionDelay: ".5s",
                      transitionProperty: "opacity",
                    }}
                  >
                    <Row className="mt-4">
                      <Col>
                        <h2 className="mini-title">Dados Gerais:</h2>
                        <p className="small-label mb-2">Informações essenciais de identificação e registro pessoal.</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} lg={6}>
                        <span>
                          Nome Completo <Required />
                        </span>
                        <InputText
                          required={true}
                          disabled={!!isWaitingResponse}
                          placeholder="..."
                          value={trainee?.name}
                          onChange={__ev => {
                            settrainee({
                              ...trainee,
                              name: __ev.target.value,
                            });
                          }}
                        />
                      </Col>
                      <Col sm={12} lg={3}>
                        <span>
                          RG <Required />
                        </span>
                        <IntegerNumber
                          required={true}
                          disabled={!!isWaitingResponse}
                          value={trainee?.rg}
                          valueChange={__ev => {
                            settrainee({
                              ...trainee,
                              rg: __ev,
                            });
                          }}
                          maxLength={20}
                        />
                      </Col>
                      <Col className="flex">
                        <span>
                          Orgão Emissor <Required />
                        </span>
                        <div className="ano-periodo">
                          <InputText
                            required={true}
                            disabled={!!isWaitingResponse}
                            value={trainee?.ssp}
                            onChange={__ev => {
                              settrainee({
                                ...trainee,
                                ssp: __ev.target.value,
                              });
                            }}
                            maxLength={6}
                          />
                          <Slct
                            required={true}
                            isDisabled={!!isWaitingResponse}
                            options={states?.map(__state => ({ value: __state.value, label: __state.uf })) || []}
                            value={trainee?.ssp_state_id}
                            onChange={__ev => {
                              settrainee({
                                ...trainee,
                                ssp_state_id: parseInt(__ev.value),
                              });
                            }}
                            placeholder="..."
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col sm={12} lg={3}>
                        <span>
                          CPF <Required />
                        </span>
                        <InputDocument
                          required={true}
                          disabled={!!isWaitingResponse}
                          value={trainee?.cpf}
                          type="cpf"
                          valueChange={__ev => {
                            settrainee({
                              ...trainee,
                              cpf: String(__ev),
                            });
                          }}
                        />
                      </Col>
                      <Col sm={12} lg={3}>
                        <span>
                          Data de Nascimento <Required />
                        </span>
                        <DatePicker
                          required={true}
                          disabled={!!isWaitingResponse}
                          selected={trainee?.date_birth ? new Date(trainee?.date_birth) : null}
                          changeDate={__ev => {
                            settrainee({
                              ...trainee,
                              date_birth: __ev,
                            });
                          }}
                        />
                      </Col>
                      <Col sm={12} lg={3}>
                        <span>
                          Estado Civil <Required />
                        </span>
                        <Slct
                          required={true}
                          isDisabled={!!isWaitingResponse}
                          options={[
                            { label: "Solteiro(a)", value: "solteiro" },
                            { label: "Casado(a)", value: "casado" },
                          ]}
                          value={trainee?.marital_status}
                          onChange={__ev => {
                            settrainee({
                              ...trainee,
                              marital_status: __ev.value,
                            });
                          }}
                          placeholder="..."
                        />
                      </Col>
                      <Col sm={12} lg={3}>
                        <span>
                          Gênero <Required />
                        </span>
                        <Slct
                          required={true}
                          isDisabled={!!isWaitingResponse}
                          options={[
                            { label: "Masculino", value: "M" },
                            { label: "Feminino", value: "F" },
                            { label: "Prefiro não informar", value: "NI" },
                          ]}
                          value={trainee?.gender}
                          onChange={__ev => {
                            settrainee({
                              ...trainee,
                              gender: __ev.value,
                            });
                          }}
                          placeholder="..."
                        />
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col sm={6}>
                        <span>Foto Segurando RG</span>
                        <File
                          disabled={!!isWaitingResponse}
                          file_id={trainee?.files?.rg}
                          file_to_upload={trainee?.files_to_upload?.rg}
                          setFile={__file => {
                            settrainee({
                              ...trainee,
                              files_to_upload: {
                                ...trainee?.files_to_upload,
                                rg: __file,
                              },
                            });
                          }}
                          title="Foto Segurando RG"
                        />
                      </Col>
                    </Row>
                    <div className="divisor mt-3 mb-3"></div>
                    <Row>
                      <Col>
                        <h2 className="mini-title">Endereço:</h2>
                        <p className="small-label mb-2">Informações detalhadas sobre o local de residência.</p>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col sm={12} lg={3}>
                        <div className="position-relative">
                          <span>
                            CEP <Required />
                          </span>
                          <a
                            href="https://buscacepinter.correios.com.br/app/endereco/index.php?t"
                            rel="noopener noreferrer"
                            target="_blank"
                            className="im-nav"
                          >
                            Buscar CEP
                          </a>
                          <Cep
                            required={true}
                            disabled={!!isWaitingResponse}
                            value={trainee?.cep}
                            valueChange={__ev => {
                              settrainee({
                                ...trainee,
                                cep: __ev,
                              });
                            }}
                            loadData={{
                              states: states || [],
                              afterSuccess: __callback => {
                                settrainee({
                                  ...trainee,
                                  address: __callback.address || trainee?.address,
                                  district: __callback.district || trainee?.district,
                                  city_id: __callback.city_id,
                                  state_id: __callback.state_id,
                                });
                              },
                            }}
                          />
                        </div>
                      </Col>
                      <Col sm={12} lg={2}>
                        <span>
                          Número <Required />
                        </span>
                        <IntegerNumber
                          required={true}
                          disabled={!!isWaitingResponse}
                          value={trainee?.number}
                          valueChange={__ev => {
                            settrainee({
                              ...trainee,
                              number: __ev,
                            });
                          }}
                          maxLength={5}
                        />
                      </Col>
                      <Col sm={12} lg={7}>
                        <span>
                          Endereço <Required />
                        </span>
                        <InputText
                          required={true}
                          disabled={!!isWaitingResponse}
                          value={trainee?.address}
                          onChange={__ev => {
                            settrainee({
                              ...trainee,
                              address: __ev.target.value,
                            });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col sm={12} lg={3}>
                        <span>
                          Bairro <Required />
                        </span>
                        <InputText
                          required={true}
                          disabled={!!isWaitingResponse}
                          value={trainee?.district}
                          onChange={__ev => {
                            settrainee({
                              ...trainee,
                              district: __ev.target.value,
                            });
                          }}
                        />
                      </Col>
                      <Col sm={12} lg={3}>
                        <span>
                          Estado <Required />
                        </span>
                        <Slct
                          required={true}
                          isDisabled={!!isWaitingResponse}
                          options={states || []}
                          value={trainee?.state_id}
                          onChange={__ev => {
                            settrainee({
                              ...trainee,
                              state_id: __ev.value,
                              city_id: null,
                            });
                          }}
                          placeholder="..."
                        />
                      </Col>
                      <Col sm={12} lg={3}>
                        <span>
                          Cidade <Required />
                        </span>
                        {!isLoadingCities ? (
                          <Slct
                            required={true}
                            isDisabled={!!isWaitingResponse}
                            options={cities || []}
                            value={trainee?.city_id}
                            onChange={__ev => {
                              settrainee({
                                ...trainee,
                                city_id: __ev.value,
                              });
                            }}
                            placeholder="..."
                          />
                        ) : (
                          <Loading small />
                        )}
                      </Col>
                      <Col>
                        <span>Complemento</span>
                        <InputText
                          disabled={!!isWaitingResponse}
                          value={trainee?.complement}
                          onChange={__ev => {
                            settrainee({
                              ...trainee,
                              complement: __ev.target.value,
                            });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col sm={12} lg={6}>
                        <span>Comprovante de Residência</span>
                        <File
                          disabled={!!isWaitingResponse}
                          file_id={trainee?.files?.proof}
                          file_to_upload={trainee?.files_to_upload?.proof}
                          setFile={__file => {
                            settrainee({
                              ...trainee,
                              files_to_upload: {
                                ...trainee?.files_to_upload,
                                proof: __file,
                              },
                            });
                          }}
                          title="Comprovante de Residência"
                        />
                      </Col>
                    </Row>
                    <div className="divisor mt-3 mb-3"></div>
                    <Row>
                      <Col>
                        <h2 className="mini-title">Contato:</h2>
                        <p className="small-label mb-2">Canais disponíveis para comunicação e notificações.</p>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col sm={12} lg={3}>
                        <div className="position-relative">
                          <span>
                            Celular <Required />
                          </span>
                          <Phone
                            required={true}
                            disabled={!!isWaitingResponse}
                            value={trainee?.cell}
                            valueChange={__ev => {
                              settrainee({
                                ...trainee,
                                cell: __ev,
                              });
                            }}
                          />
                          <label className="im-checkbox-2">
                            <Checkbox
                              disabled={!!isWaitingResponse}
                              name="is_whatsapp"
                              checked={trainee?.is_whatsapp || 0}
                              onChange={ev => {
                                settrainee({
                                  ...trainee,
                                  is_whatsapp: ev.target.checked,
                                });
                              }}
                            />
                            <span className="fs-12">WhatsApp?</span>
                          </label>
                        </div>
                      </Col>
                      <Col sm={12} lg={3}>
                        <span>Outro Telefone</span>
                        <Phone
                          disabled={!!isWaitingResponse}
                          value={trainee?.phone}
                          valueChange={__ev => {
                            settrainee({
                              ...trainee,
                              phone: __ev,
                            });
                          }}
                        />
                      </Col>
                      <Col>
                        <span>
                          E-mail <Required />
                        </span>
                        <InputEmail
                          required={true}
                          disabled={!!isWaitingResponse}
                          value={trainee?.email}
                          onChange={__ev => {
                            settrainee({
                              ...trainee,
                              email: __ev.target.value,
                            });
                          }}
                          placeholder="usuario@email.com"
                        />
                      </Col>
                      <Col>
                        <span>Instagram</span>
                        <InputText
                          disabled={!!isWaitingResponse}
                          value={trainee?.instagram}
                          onChange={__ev => {
                            settrainee({
                              ...trainee,
                              instagram: __ev.target.value,
                            });
                          }}
                          placeholder="@usuario"
                        />
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col sm={12} lg={3}>
                        <span>Responsável Legal 1</span>
                        <InputText
                          disabled={!!isWaitingResponse}
                          value={trainee?.legal_responsible1}
                          onChange={__ev => {
                            settrainee({
                              ...trainee,
                              legal_responsible1: __ev.target.value,
                            });
                          }}
                        />
                      </Col>
                      <Col sm={12} lg={3}>
                        <span>Tel. Responsável 1</span>
                        <Phone
                          disabled={!!isWaitingResponse}
                          value={trainee?.legal_cell1}
                          valueChange={__ev => {
                            settrainee({
                              ...trainee,
                              legal_cell1: __ev,
                            });
                          }}
                        />
                      </Col>
                      <Col sm={12} lg={3}>
                        <span>Responsável Legal 2</span>
                        <InputText
                          disabled={!!isWaitingResponse}
                          value={trainee?.legal_responsible2}
                          onChange={__ev => {
                            settrainee({
                              ...trainee,
                              legal_responsible2: __ev.target.value,
                            });
                          }}
                        />
                      </Col>
                      <Col sm={12} lg={3}>
                        <span>Tel. Responsável 2</span>
                        <Phone
                          disabled={!!isWaitingResponse}
                          value={trainee?.legal_cell2}
                          valueChange={__ev => {
                            settrainee({
                              ...trainee,
                              legal_cell2: __ev,
                            });
                          }}
                        />
                      </Col>
                    </Row>
                    <div className="divisor mt-3 mb-3"></div>
                    <Row>
                      <Col>
                        <h2 className="mini-title">Dados Cadastrais/Contratuais:</h2>
                        <p className="small-label mb-2">Detalhes da participação no evento e condições contratuais</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} lg={6}>
                        <span>
                          Vencimento das parcelas <Required />
                        </span>
                        <Slct
                          required={true}
                          options={[
                            { value: "5", label: "Todo dia 05" },
                            { value: "10", label: "Todo dia 10" },
                            { value: "15", label: "Todo dia 15" },
                            { value: "20", label: "Todo dia 20" },
                            { value: "25", label: "Todo dia 25" },
                          ]}
                          value={trainee?.due_date}
                          onChange={__ev => {
                            settrainee({
                              ...trainee,
                              due_date: __ev.value,
                            });
                          }}
                          placeholder="..."
                        />
                      </Col>
                      <Col sm={12} lg={3}>
                        <span>
                          Senha de Acesso <Required />
                        </span>
                        <Password
                          required={true}
                          value={trainee?.password}
                          autoComplete="off"
                          has_error={!!trainee?.password && trainee?.password?.length < 7}
                          valueChange={__ev => {
                            settrainee({
                              ...trainee,
                              password: __ev,
                            });
                          }}
                        />
                      </Col>
                      <Col sm={12} lg={3}>
                        <span>
                          Confirmar Senha <Required />
                        </span>
                        <Password
                          required={true}
                          value={trainee?.checkPassword}
                          autoComplete="off"
                          has_error={
                            trainee?.password !== trainee?.checkPassword ||
                            (!!trainee?.checkPassword && trainee?.checkPassword.length < 7)
                          }
                          valueChange={__ev => {
                            settrainee({
                              ...trainee,
                              checkPassword: __ev,
                            });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col>
                        <div className="text-end">
                          <Button
                            color="primary"
                            onClick={() => {
                              const _is_valid = validateForm(document.getElementById("form_container"));
                              if (!_is_valid) return;
                              setwizard(2);
                            }}
                            disabled={isWaitingResponse}
                          >
                            Registrar-se
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}
                {wizard === 3 && (
                  <div className="text-center">
                    <p>
                      <b>Pré-Cadastro Efetuado com Sucesso!</b>
                    </p>
                    <p>
                      Fique atento(a) a sua caixa de mensagens, estaremos analisando o seu cadastro e em breve
                      entraremos em contato! Até já!
                    </p>
                  </div>
                )}
              </>
            ) : (
              <Loading />
            )}
          </>
        ) : (
          <>Código de acesso inválido. Entre em contato com a nossa equipe.</>
        )}
      </div>
      <ModalConfirm
        show={wizard === 2}
        title="Privacidade e Termos"
        maxHeightScroll="330px"
        loading={isWaitingResponse}
        disableClose={isWaitingResponse}
        text={
          <>
            <p>
              <b>TERMOS DE USO E POLÍTICA DE PRIVACIDADE</b>
            </p>
            <p>
              <b>1. Introdução</b>
            </p>
            <p>
              Bem-vindo ao sistema de gestão de formaturas da Formou. Estes Termos de Uso e Política de Privacidade
              ("Termos") regulam o uso do nosso sistema pelos formandos. Ao usar nosso sistema, você concorda em cumprir
              estes Termos.
            </p>
            <p>
              <b>2. Uso do Sistema</b>
            </p>
            <p>
              2.1. Registro: Para usar nosso sistema, você deve se registrar e fornecer informações precisas e
              atualizadas. Você é responsável por manter suas credenciais de login seguras.
            </p>
            <p>
              2.2. Uso Autorizado: Você concorda em usar o sistema somente para fins relacionados à sua formatura e de
              acordo com todas as leis aplicáveis.
            </p>
            <p>
              2.3. Conteúdo do Usuário: Qualquer conteúdo que você envie ou compartilhe em nosso sistema, como fotos e
              mensagens, deve estar em conformidade com nossas políticas e com as leis aplicáveis. Reservamo-nos o
              direito de remover conteúdo inadequado.
            </p>
            <p>
              <b>3. Privacidade</b>
            </p>
            <p>
              3.1. Coleta de Informações: Coletamos informações pessoais para melhorar nossos serviços. Saiba mais em
              nossa Política de Privacidade.
            </p>
            <p>
              3.2. Uso de Informações: Usamos suas informações apenas para fornecer serviços relacionados à formatura e
              melhorar nosso sistema.
            </p>
            <p>
              3.3. Compartilhamento de Informações: Não compartilhamos suas informações pessoais com terceiros sem seu
              consentimento, exceto quando exigido por lei.
            </p>
            <p>
              <b>4. Segurança</b>
            </p>
            <p>
              4.1. Proteção de Dados: Tomamos medidas para proteger seus dados, mas não podemos garantir segurança
              absoluta. Você é responsável por manter a segurança de suas credenciais.
            </p>
            <p>
              <b>5. Cancelamento de Conta</b>
            </p>
            <p>5.1. Você pode encerrar sua conta a qualquer momento, seguindo as instruções em nosso sistema.</p>
            <p>
              <b>6. Alterações nos Termos</b>
            </p>
            <p>
              Reservamo-nos o direito de alterar esses Termos a qualquer momento. Notificaremos os usuários de quaisquer
              alterações significativas.
            </p>
            <p>
              <b>7. Contato</b>
            </p>
            <p>
              Se você tiver alguma dúvida ou preocupação sobre estes Termos ou nossa Política de Privacidade, entre em
              contato conosco em contato@entaoformou.com.br.
            </p>
          </>
        }
        options={[
          {
            label: "Cancelar",
            buttonColor: "primary_ghost",
            effect: () => {
              setwizard(1);
            },
          },
          {
            label: "Concordo",
            buttonColor: "primary",
            effect: signUp,
          },
        ]}
        closeModal={() => {
          setwizard(1);
        }}
      />
    </>
  );
}
